import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';
import ServiceDetail from './pages/services/ServiceDetail';
import Gallery from './pages/Gallery';
import Values from './pages/Values';
import Testimonials from './pages/Testimonials';
import FAQ from './pages/FAQ';
import Admin from './pages/Admin';
import DoorHanger from './pages/DoorHanger';
import DoorHangerTrueNorth from './pages/DoorHangerTrueNorth';
import DoorHangerDoubleSided from './pages/DoorHangerDoubleSided';
import Concrete from './pages/Concrete';
import Commercial from './pages/Commercial';
import HolidayLighting from './pages/HolidayLighting';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/services/concrete" element={<Concrete />} />
          <Route path="/services/holiday-lighting" element={<HolidayLighting />} />
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/values" element={<Values />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/door-hanger" element={<DoorHanger />} />
          <Route path="/door-hanger-truenorth" element={<DoorHangerTrueNorth />} />
          <Route path="/door-hanger-double" element={<DoorHangerDoubleSided />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;